import * as moment from "moment";
import * as React from "react";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMessageDetail from "../../types/IMessageDetail";

interface IMessageRecipientRowProps extends IMessageDetail, ITranslationProps {
    onclick: (messageID: number, messageType: string) => void;
}

function MessageRecipientRow(p: IMessageRecipientRowProps) {

    function onRowClick() {
        p.onclick(p.messageHeaderID, p.messageType);
    }

    return (
        <tr onClick={onRowClick} className="messagerecipient-row" title={p.t("Global.ClickForDetails")}>
            <td>{p.recipient}</td>
            <td>{p.referenceID}</td>
            <td>{p.description}</td>
            <td>{p.isHtmlFormat ? <em>&lt;html&gt;...&lt;/html&gt;</em> : truncate(p.messageContent)}</td>
            <td>{p.dateTimeCreated ? moment(p.dateTimeCreated).format(Constants.MOMENT_FORMAT_DATETIME) : ""}</td>
            <td>{p.messageType}</td>
        </tr>
    );
}

function truncate(text: string) {
    if (text && text.length > 50) {
        return text.substr(0, 50) + "...";
    }
    return text;
}

export default translateComponent(MessageRecipientRow);



// WEBPACK FOOTER //
// ./src/components/MessageRecipientList/MessageRecipientRow.tsx